import { render, staticRenderFns } from "./TableAmountsByStatus.vue?vue&type=template&id=1a67077a&"
import script from "./TableAmountsByStatus.vue?vue&type=script&lang=js&"
export * from "./TableAmountsByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports